import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import Text from '../../../../../General/Text';
import Button from '../../../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  HandleStyled,
  TextStyled,
  ContentStyled,
  CardIconsWrapperStyled,
  DisabledWebpayStyled,
} from './style/MethodStyled';
import { ReactComponent as ArrowNavIcon } from '../../../../../../images/ui/arrow-nav.svg';
import { ReactComponent as CardIcons } from '../../../../../../images/ui/payment-card-options.svg';
import { ReactComponent as WarningIcon } from '../../../../../../images/ui/balance-warning.svg';
import { GoogleTagManager } from '../../../../../../helpers';

const WebpayMethod = ({ buyCallback, active }) => {
  const [toggled, setToggle] = useState(false);
  const clickHandler = () => {
    setToggle(!toggled);
  };

  const buyHandler = () => {
    buyCallback('WEBPAY');

    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Home',
      eventAction: 'Pago webpay',
      eventTag: 'BTN_COMPRAR_BOLSA_WEBPAY',
    });
  };
  return (
    <ContainerStyled>
      <HeaderStyled>
        <TextStyled>
          <Text
            text="Pagar con Webpay"
            color="#381451"
            size="18px"
            weight="500"
          />
        </TextStyled>
        <HandleStyled
          data-testid="toggle-handler"
          onClick={clickHandler}
          toggled={toggled}
        >
          <ArrowNavIcon />
        </HandleStyled>
      </HeaderStyled>
      <AnimatePresence initial={false}>
        {toggled && (
          <ContentStyled
            data-testid="toggle-content"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3 }}
          >
            {!active && (
              <DisabledWebpayStyled>
                <WarningIcon />
                <Text
                  text="Lo sentimos, el medio de pago no se encuentra disponible en estos momentos."
                  color="#E92070"
                  size="13px"
                  weight="400"
                />
              </DisabledWebpayStyled>
            )}
            <Button
              color="bubbleGum"
              maxWidth="100%"
              disabled={!active}
              click={buyHandler}
              margin={active ? '20px 0px' : '20px 0px 0px 0px'}
            >
              PAGAR
            </Button>
            {active && (
              <CardIconsWrapperStyled>
                <CardIcons />
              </CardIconsWrapperStyled>
            )}
          </ContentStyled>
        )}
      </AnimatePresence>
    </ContainerStyled>
  );
};

WebpayMethod.propTypes = {
  buyCallback: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};

export default WebpayMethod;
